const automationFlowChildren = [
    {
        path: 'list',
        name: 'authMode_automation_list',
        meta: {
            access: ['AUTH_AUTOMATION'],
            title: 'authMode_automation_list',
            icon: 'icon-Group',
            hideInMenu: true,
        },
        component: () => import(/* webpackChunkName: "automation" */ '@/views/main/automation/AutomationFlow/list.vue'),
    },
    {
        path: 'new',
        name: 'authMode_automation_list_new',
        meta: {
            access: ['AUTH_AUTOMATION'],
            title: 'authMode_automation_list_new',
            icon: 'icon-Group',
            hideInMenu: true,
        },
        props: (route: any) => {
            return {
                ...route.query,
                ...route.params,
            };
        },
        component: () => import(/* webpackChunkName: "automation2" */ '@/views/main/automation/AutomationFlow/edit.vue'),
    },
    {
        path: 'data/:id',
        name: 'authMode_automation_list_data',
        meta: {
            access: ['AUTH_AUTOMATION'],
            title: 'authMode_automation_list_data',
            icon: 'icon-Group',
            hideInMenu: true,
        },
        props: (route: any) => {
            return {
                ...route.query,
                ...route.params,
            };
        },
        component: () => import(/* webpackChunkName: "automation2" */ '@/views/main/automation/AutomationFlow/data.vue'),
    },
    {
        path: ':id',
        name: 'authMode_automation_list_edit',
        meta: {
            access: ['AUTH_AUTOMATION'],
            title: 'authMode_automation_list_edit',
            icon: 'icon-Group',
            hideInMenu: true,
        },
        props: (route: any) => {
            return {
                ...route.query,
                ...route.params,
            };
        },
        component: () => import(/* webpackChunkName: "automation2" */ '@/views/main/automation/AutomationFlow/edit.vue'),
    },
];

export const automationFlow = {
    path: 'automation-flow',
    name: 'authMode_automation_flow',
    meta: {
        access: ['AUTH_AUTOMATION'],
        title: 'authMode_automation_list',
        icon: 'icon-Group',
        notPageView: true,
    },
    component: () => import(/* webpackChunkName: "automation" */ '@/views/main/automation/AutomationFlow/index.vue'),
    redirect: { name: 'authMode_automation_list' },
    children: automationFlowChildren,
};

export const defaultAutomation = {
    path: 'automation',
    name: 'authMode_automation',
    meta: {
        access: ['AUTH_AUTOMATION_MANAGEMENT'],
        title: 'authMode_automation',
        icon: 'icon-Group',
        notPageView: true,
    },
    component: () => import(/* webpackChunkName: "automation" */ '@/views/main/automation/AutomationFlow/index.vue'),
    children: [
        {
            path: 'robot',
            name: 'automation_ai_robot',
            meta: {
                access: ['AUTH_AI_ROBOT'],
                title: 'automation_ai_robot',
                icon: 'icon-zidonghua',
                documentTitle: 'automation_ai_robot',
                notPageView: true,
            },
            redirect: { name: 'automation_ai_robot_list' },
            component: () => import(/* webpackChunkName: "robot" */ '@/views/main/automation/Robot/index.vue'),
            children: [
                {
                    path: 'list',
                    name: 'automation_ai_robot_list',
                    meta: {
                        access: ['AUTH_AI_ROBOT'],
                        title: 'automation_ai_robot_list',
                        icon: 'icon-zidonghua',
                        documentTitle: 'automation_ai_robot',
                        hideInMenu: true,
                    },
                    component: () => import(/* webpackChunkName: "robot" */ '@/views/main/automation/Robot/List/index.vue'),
                },
                {
                    path: 'create/:id*',
                    name: 'automation_ai_robot_create',
                    meta: {
                        access: ['AUTH_AI_ROBOT'],
                        title: 'automation_ai_robot_create',
                        icon: 'icon-zidonghua',
                        documentTitle: 'automation_ai_robot',
                        hideInMenu: true,
                    },
                    component: () => import(/* webpackChunkName: "robot" */ '@/views/main/automation/Robot/Create/index.vue'),
                },
                {
                    path: 'apply/:id*',
                    name: 'legacy_automation_ai_robot_apply',
                    meta: {
                        title: 'appstore',
                        icon: 'icon-gongju',
                        documentTitle: 'appstore',
                        hideInMenu: true,
                        activeMenu: 'appstore',
                    },
                    redirect: (to: any) => ({
                        name: 'automation_ai_robot_apply',
                        params: to.params,
                        query: to.query,
                    }),
                },
            ],
        },
        // 兼容旧路由：/automation/list -> /automation-flow/list
        {
            path: 'list',
            name: 'legacy_authMode_automation_list',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: { name: 'authMode_automation_list' },
        },
        // 兼容旧路由：/automation/new -> /automation-flow/new
        {
            path: 'new',
            name: 'legacy_authMode_automation_list_new',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: { name: 'authMode_automation_list_new' },
        },
        // 兼容旧路由：/automation/data/:id -> /automation-flow/data/:id
        {
            path: 'data/:id',
            name: 'legacy_authMode_automation_list_data',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: (to: any) => ({
                name: 'authMode_automation_list_data',
                params: to.params,
                query: to.query,
            }),
        },
        // 兼容旧路由：/automation/:id -> /automation-flow/:id
        {
            path: ':id',
            name: 'legacy_authMode_automation_list_edit',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: (to: any) => ({
                name: 'authMode_automation_list_edit',
                params: to.params,
                query: to.query,
            }),
        },
        {
            path: 'faq_management',
            name: 'authMode_automation_ai_corpus',
            meta: {
                access: ['AUTH_FAQ_MANAGEMENT'],
                title: 'authMode_automation_ai_corpus',
                icon: 'icon-Group',
            },
            component: () => import(/* webpackChunkName: "faq" */ '@/views/main/authMode/Faq/Management/index.vue'),
        },
        /** 待废弃 start */
        {
            path: 'split_link',
            name: 'authMode_automation_split_link',
            meta: {
                access: ['AUTH_SPLIT_LINK'],
                hideInMenu: true,
                notPageView: true,
            },
            redirect: { name: 'marketing_split_link' },
        },
        {
            path: 'insight/:id',
            name: 'authMode_automation_split_link_insight',
            meta: {
                access: ['AUTH_SPLIT_LINK'],
                hideInMenu: true,
                notPageView: true,
            },
            props: (route: any) => {
                return {
                    ...route.query,
                    ...route.params,
                };
            },
            redirect: { name: 'marketing_split_link_insight' },
        },
        /** 待废弃 end */
        {
            path: 'helpdesk',
            name: 'helpdesk',
            meta: {
                access: ['AUTH_HELPDESK_PAGE'],
                title: 'helpdesk',
            },
        },
    ],
};

export const cainiaoAutomation = {
    path: 'automation',
    name: 'authMode_automation',
    meta: {
        access: ['AUTH_AUTOMATION_MANAGEMENT'],
        title: 'authMode_automation_list',
        icon: 'icon-Group',
        notPageView: true,
    },
    component: () => import(/* webpackChunkName: "automation" */ '@/views/main/automation/AutomationFlow/index.vue'),
    redirect: { name: 'authMode_automation_list' },
    children: [
        // 兼容旧路由：/automation/list -> /automation-flow/list
        {
            path: 'list',
            name: 'legacy_cainiao_automation_list',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: { name: 'authMode_automation_list' },
        },
        // 兼容旧路由：/automation/new -> /automation-flow/new
        {
            path: 'new',
            name: 'legacy_cainiao_automation_list_new',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: { name: 'authMode_automation_list_new' },
        },
        // 兼容旧路由：/automation/data/:id -> /automation-flow/data/:id
        {
            path: 'data/:id',
            name: 'legacy_cainiao_automation_list_data',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: (to: any) => ({
                name: 'authMode_automation_list_data',
                params: to.params,
                query: to.query,
            }),
        },
        // 兼容旧路由：/automation/:id -> /automation-flow/:id
        {
            path: ':id',
            name: 'legacy_cainiao_automation_list_edit',
            meta: {
                hideInMenu: true,
                notPageView: true,
            },
            redirect: (to: any) => ({
                name: 'authMode_automation_list_edit',
                params: to.params,
                query: to.query,
            }),
        },
    ],
};
